const cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;';
const copyErrorMessage = 'Failed to copy value to clipboard. Unknown type.';

const copyToClipboard = (input) => {
  let value;

  if (typeof input !== 'string') {
    try {
      value = JSON.stringify(input);
    } catch (e) {
      throw new Error(copyErrorMessage);
    }
  } else {
    value = input;
  }

  const textarea = document.createElement('textarea');

  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.cssText = cssText;

  document.body.appendChild(textarea);

  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textarea.contentEditable = true;
    textarea.readOnly = true;

    const range = document.createRange();
    range.selectNodeContents(textarea);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textarea.setSelectionRange(0, 999999);
  } else {
    textarea.select();
  }

  let success = false;

  try {
    success = document.execCommand('copy');
  } catch (err) {
    console.warn(err);
  }

  document.body.removeChild(textarea);

  return success;
};

const generateId = ((id) => () => `$${id++}`)(1);
const handlers = {};

const removeHandler = (id) => {
  if (!id) {
    return;
  }
  handlers[id] = null;
  delete handlers[id];
};

const addHandler = (func) => {
  const id = generateId();
  handlers[id] = func;
  return id;
};

const bindClipboardClick = (el, binding) => {
  const { value } = binding;
  const clickEventHandler = (event) => {
    if (Object.prototype.hasOwnProperty.call(binding, 'value')) {
      const payload = {
        value: typeof value === 'function' ? value() : value,
        event
      };

      const handlerId = copyToClipboard(payload.value)
        ? el.dataset.clipboardSuccessHandler
        : el.dataset.clipboardErrorHandler;
      const handler = handlers[handlerId];

      if (handler) {
        handler(payload);
      }
    }
  };

  const clickEventHandlerId = addHandler(clickEventHandler);
  el.dataset.clipboardClickHandler = clickEventHandlerId;
  el.addEventListener('click', handlers[clickEventHandlerId]);
};

const applyBinding = (el, binding) => {
  const { arg, value } = binding;

  switch (arg) {
    case 'error':
      el.dataset.clipboardErrorHandler = addHandler(value);
      break;
    case 'success':
      el.dataset.clipboardSuccessHandler = addHandler(value);
      break;
    default:
      bindClipboardClick(el, binding);
  }
};

const cleanupBinding = (el) => {
  const {
    clipboardSuccessHandler,
    clipboardErrorHandler,
    clipboardClickHandler
  } = el.dataset;

  removeHandler(clipboardSuccessHandler);
  removeHandler(clipboardErrorHandler);

  if (clipboardClickHandler) {
    el.removeEventListener('click', handlers[clipboardClickHandler]);
    removeHandler(clipboardClickHandler);
  }
}

export default {
  install(app) {
    app.config.globalProperties.$clipboard = copyToClipboard;
    app.directive('clipboard', {
      beforeMount(el, binding) {
        applyBinding(el, binding);
      },
      updated(el, binding) {
        cleanupBinding(el);
        applyBinding(el, binding);
      },
      unmounted(el) {
        cleanupBinding(el);
      }
    });
  }
};
